var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 36.75C8.09375 36.75 5.40625 36.75 5.40625 34.125C5.40625 31.5 8.09375 23.625 21.5 23.625C34.9063 23.625 37.5938 31.5 37.5938 34.125C37.5938 36.75 34.9063 36.75 34.9063 36.75H8.09375ZM21.5 21C23.6431 21 25.6982 20.1491 27.1859 18.6614C28.6736 17.1736 29.5312 15.1185 29.5312 13.125C29.5312 11.1315 28.6736 9.07641 27.1859 7.58861C25.6982 6.10081 23.6431 5.25 21.5 5.25C19.3569 5.25 17.3018 6.10081 15.8141 7.58861C14.3264 9.07641 13.4688 11.1315 13.4688 13.125C13.4688 15.1185 14.3264 17.1736 15.8141 18.6614C17.3018 20.1491 19.3569 21 21.5 21Z",
    fill: "#003738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.8032fdb5b0c9d50f241d3ea9a005a4cc.svg";
export { ForwardRef as ReactComponent };